import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { DropIndicator } from '../DropIndicator';
import { useCurrentTeaId, useCurrentTeaAction } from '@saucerjs/core';
import { useDragAndDrop } from '../../hooks/useDragAndDrop';
import { RenderWrapperTools } from './tools';
export var RenderWrapper = React.memo(function (props) {
    var path = props.path, tea = props.tea, _a = props.canDrop, canDrop = _a === void 0 ? true : _a;
    var type = tea.type;
    var currentSelectedTeaId = useCurrentTeaId();
    var isSelected = tea.id === currentSelectedTeaId;
    var setCurrentTeaId = useCurrentTeaAction().setCurrentTeaId;
    var _b = useDragAndDrop({
        path: path,
        tea: tea,
        canDrop: canDrop,
    }), dndRef = _b.dndRef, isOverCurrent = _b.isOverCurrent, dragName = _b.dragName, dndClassName = _b.dndClassName, dndStyle = _b.dndStyle;
    var handleClick = useCallback(function (e) {
        e.stopPropagation();
        setCurrentTeaId(tea.id);
    }, [setCurrentTeaId, tea.id]);
    var el = useMemo(function () {
        if (type === 'container') {
            return (React.createElement(React.Fragment, null,
                props.children,
                isOverCurrent && React.createElement(DropIndicator, { name: dragName })));
        }
        else {
            return React.createElement(React.Fragment, null, props.children);
        }
    }, [type, props.children, isOverCurrent, dragName]);
    return (React.createElement("div", { ref: dndRef, className: classNames(dndClassName, 'saucer-render-wrapper', {
            'saucer-render-wrapper__selected': isSelected,
            'saucer-render-wrapper__hover': isOverCurrent,
        }), style: dndStyle, onClick: handleClick },
        el,
        isSelected && currentSelectedTeaId !== 'root' && (React.createElement(RenderWrapperTools, null))));
});
RenderWrapper.displayName = 'RenderWrapper';
